import "ant-design-vue/es/modal/style";
import _Modal from "ant-design-vue/es/modal";
import "ant-design-vue/es/popconfirm/style";
import _Popconfirm from "ant-design-vue/es/popconfirm";
import { __awaiter, __generator } from "tslib";
import { useService } from '@kaokei/use-vue-service';
import { defineComponent, createVNode, computed, onUnmounted, reactive } from 'vue';
import { ExamService } from '@/services/exam/exam.service';
import HeaderTip from './HeaderTip.vue';
import Countdown from './Countdown.vue';
import WorkProfileDialog from './WorkProfileDialog.vue';
import { CountdownService } from '@/services/exam/countdown.service';
import { useRouter, useRoute } from 'vue-router';
import { ExclamationCircleOutlined, LeftOutlined, SendOutlined, FileTextOutlined } from '@ant-design/icons-vue';
import { EnvCheckService } from '@/services/exam/envCheck.service';
import { QuestionService } from '@/services/exam/question.service';
import { TOKEN_INVALID_ERRCODE, formatDateToSecond } from '@/utils';
export default defineComponent({
  name: 'UserExamHeader',
  components: {
    HeaderTip: HeaderTip,
    Countdown: Countdown,
    SendOutlined: SendOutlined,
    FileTextOutlined: FileTextOutlined,
    LeftOutlined: LeftOutlined,
    WorkProfileDialog: WorkProfileDialog,
    APopconfirm: _Popconfirm
  },
  setup: function () {
    var _this = this;
    var router = useRouter();
    var route = useRoute();
    var examService = useService(ExamService);
    var questionService = useService(QuestionService);
    var countdownService = useService(CountdownService);
    var envCheckService = useService(EnvCheckService);
    function jsonToQueryString(json) {
      if (!json) return;
      if (typeof json === 'object') {
        return Object.keys(json).map(function (key) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
        }).join('&');
      }
    }
    var goBack = function (withUrlJump) {
      var _a;
      if (withUrlJump === void 0) {
        withUrlJump = false;
      }
      var newQuery = ((_a = route.meta) === null || _a === void 0 ? void 0 : _a.ignoreQuery) ? undefined : route.query;
      if (withUrlJump) {
        window.location.replace("\n        /user".concat(newQuery ? '?' : '').concat(jsonToQueryString(newQuery)));
      } else {
        router.replace({
          name: 'UserItemList',
          query: newQuery
        });
      }
    };
    // 返回试卷，隐藏ide
    // 需要判断是否是自由创作题，需要提示用户填写作品简介
    var onHideIde = function () {
      if (!questionService.ideIframeDom || examService.answerMode) {
        // 当iframe还没有加载完成时，直接返回到答题卡页面
        questionService.showIde = false;
        return;
      }
      if (questionService.isProgramCreation) {
        var userAnswer = examService.getUserAnswerByQuestionId(questionService.question.id);
        if (!((userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.creationTitle) && (userAnswer === null || userAnswer === void 0 ? void 0 : userAnswer.creationSummary))) {
          return _Modal.confirm({
            title: '提示',
            icon: createVNode(ExclamationCircleOutlined),
            content: '请填写作品介绍，让大家进一步了解你的作品！',
            okText: '去填写',
            cancelText: '离开',
            onOk: function () {
              questionService.showWorkProfileDialog();
            },
            onCancel: function () {
              questionService.hideIdeEvent();
            }
          });
        }
      }
      questionService.hideIdeEvent();
    };
    var uploadSentryLog = function (api, res) {
      // eslint-disable-next-line
      console.log('setTag', 'api', api);
    };
    var onManualSubmitExam = function () {
      _Modal.confirm({
        title: '是否确认提交本次答题记录？',
        icon: createVNode(ExclamationCircleOutlined),
        content: '交卷后将不能再次做题，确认交卷吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: function () {
          examService.submitExam().then(function (res) {
            if (res && (res.errCode === 0 || res.errCode === 5010)) {
              examService.destroy();
              _Modal.success({
                title: '交卷成功',
                content: '交卷成功',
                onOk: function () {
                  return goBack(true);
                }
              });
            } else if (!(res && res.errCode === TOKEN_INVALID_ERRCODE)) {
              // 这里需要排除掉交卷的时候用户已经登出系统
              _Modal.error({
                title: '交卷失败',
                content: '交卷失败，请稍后再试'
              });
              uploadSentryLog('onManualSubmitExam', res);
            }
          });
        }
      });
    };
    var onAutoSubmitExam = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              if (!questionService.showIde) return [3 /*break*/, 2];
              return [4 /*yield*/, questionService.trySaveIde()];
            case 1:
              _a.sent();
              _a.label = 2;
            case 2:
              examService.submitExam().then(function (res) {
                if (res && (res.errCode === 0 || res.errCode === 5010)) {
                  examService.destroy();
                  // 顺便销毁手动交卷的弹窗
                  _Modal.destroyAll();
                  _Modal.success({
                    title: '考试结束',
                    content: '考试已结束，系统将自动保存答题记录并交卷',
                    onOk: function () {
                      return goBack(true);
                    }
                  });
                } else if (!(res && res.errCode === TOKEN_INVALID_ERRCODE)) {
                  // 这里需要排除掉交卷的时候用户已经登出系统
                  _Modal.error({
                    title: '考试结束',
                    content: '考试已结束，自动交卷失败，请手动交卷'
                  });
                  uploadSentryLog('onAutoSubmitExam', res);
                }
              });
              return [2 /*return*/];
          }
        });
      });
    };
    var tip = computed(function () {
      if (envCheckService.isBrowserNotValid) {
        return 1;
      } else if (envCheckService.isVideoNotAllowed) {
        return 2;
      } else if (envCheckService.isVideoError) {
        return 3;
      } else {
        return 0;
      }
    });
    if (!examService.answerMode) {
      countdownService.registerCallback(onAutoSubmitExam);
      countdownService.startCountdown().then(function () {
        if (countdownService.remainTime <= 0) {
          // 正常不会进入这个逻辑
          // 因为如果是已交卷，则startExam接口会报错
          onAutoSubmitExam();
        }
      });
    }
    // 利用firstTimeShowIde的展示隐藏 处理重新加载iframe
    var IframeConf = reactive({
      timer: undefined,
      disabled: false
    });
    var reloadIframe = function () {
      clearTimeout(IframeConf.timer);
      questionService.ideIframeSaving = false;
      // 该操作可能导致ide代码丢失 请谨慎使用
      IframeConf.timer = setTimeout(function () {
        var _a, _b;
        questionService.iframeRefreshTag = Date.now();
        window.hetaoTrack('element_click', {
          elementName: '重载项目-确定',
          pageName: '赛考页面',
          url: location.href,
          id: questionService.question.id,
          userId: ((_b = (_a = questionService.userService) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId) || 0
        });
      }, 80);
    };
    var reloadIframeClick = function () {
      var _a, _b;
      window.hetaoTrack('element_click', {
        elementName: '重载项目-入口',
        pageName: '赛考页面',
        url: location.href,
        id: questionService.question.id,
        userId: ((_b = (_a = questionService.userService) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId) || 0
      });
    };
    onUnmounted(function () {
      clearTimeout(IframeConf.timer);
      _Modal.destroyAll();
    });
    return {
      examService: examService,
      questionService: questionService,
      countdownService: countdownService,
      onManualSubmitExam: onManualSubmitExam,
      onAutoSubmitExam: onAutoSubmitExam,
      tip: tip,
      onHideIde: onHideIde,
      formatDateToSecond: formatDateToSecond,
      IframeConf: IframeConf,
      reloadIframe: reloadIframe,
      reloadIframeClick: reloadIframeClick
    };
  }
});